define('drops/dropField/dropField',[
    'jquery',
    'lq/drop',
    'lq/style',
    'underscore'
], function ($, Drop, Style, _) {
    'use strict';

    var fileDroppedEvent = 'fileDropped';

    function DropField(options) {
        Drop.call(this, $('<div />'), null, options);

        Style.renderStyles(this, null, this.$element);
    };

    Drop.extend(DropField, Drop);

    DropField.typeName = 'DropField';

    DropField.prototype.preRender = function () {
        this.applyPosition();

        this.preventDefaultEventHandlers();

        if (this.isEventEnabled(fileDroppedEvent)) {
            this.addDropEventHandler();
        }
    };

    DropField.prototype.preventDefaultEventHandlers = function () {
        this.$element.on('dragover', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        this.$element.on('dragenter', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        this.$element.on('dragleave', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
    };

    DropField.prototype.addDropEventHandler = function () {
        var self = this;
        this.$element.on('drop', function (e) {
            if (e.originalEvent.dataTransfer) {
                if (e.originalEvent.dataTransfer.files.length) {
                    e.preventDefault();
                    e.stopPropagation();

                    _.each(e.originalEvent.dataTransfer.files, function (file) {
                        self.triggerEvent(self.data.eventing[fileDroppedEvent].raisedEventName, file);
                    });
                }
            }
        });
    };

    return DropField;
});
